import type { ReactNode } from 'react';

export const symbol_waterfall_chart: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M135-174.88q-15-14.87-15-36.12v-123q0-21.25 14.82-36.13 14.83-14.87 36-14.87Q192-385 207-370.13q15 14.88 15 36.13v123q0 21.25-14.82 36.12-14.83 14.88-36 14.88Q150-160 135-174.88Zm207-248q-15-14.87-15-36.12v-84q0-20.83 14.82-35.42 14.83-14.58 36-14.58 21.18 0 35.68 14.87Q428-563.25 428-542v84q0 20.83-14.62 35.42Q398.76-408 377.88-408 357-408 342-422.88Zm206-208q-15-14.87-15-36.12v-83q0-20.83 14.82-35.42 14.83-14.58 36-14.58 21.18 0 35.68 14.87Q634-770.25 634-749v83q0 20.83-14.62 35.42Q604.76-616 583.88-616 563-616 548-630.88Zm206 456q-15-14.87-15-36.12v-539q0-20.83 14.82-35.42 14.83-14.58 36-14.58 21.18 0 35.68 14.87Q840-770.25 840-749v539q0 20.83-14.62 35.42Q810.76-160 789.88-160 769-160 754-174.88Z"
		/>
	</svg>
);
